<template>
	<div class="po-r" style="padding: 1.46rem 0 .5rem 0;background-color: #FAFAFA;">
		<div class="big-title">{{$store.state.language == 'EN' ? 'News and information':'新闻资讯'}}</div>

		<!-- 切换按钮 -->
		<div class="posi-box" @mouseover="stop" @mouseout="pay">
			<div class="num-box fs-14 mb-20">
				<span>{{ add0(current + 1) }}</span>
				<div class="num-line"></div>
				<span style="color: #ABABAB;">{{ add0(list.length) }}</span>
			</div>
			<div class="last-one mr-20" @click="lastOne"></div>
			<div class="next-one" @click="current < list.length - 1 ? (current += 1) : (current = 0)"></div>
		</div>

		<!-- 主要内容 -->
		<div class="over-hi" :style="win_size <= 1024 ? 'margin-left:30px' : 'margin-left: 12%;'">
			<div class="box-in" :style="style">
				<div class="box-item" v-for="(v, i) in list2" :key="i" @click="$router.push({ name: 'News', query: { id: v.id },params:{ list: list2,i} })">
					<div class="box-num">{{ add0(1 + v.index) }}</div>
					<div class="title fs-18 lh-30 fw text-1">{{ v.title }}</div>
					<div class="fs-14 co-8">{{ v.createDate }}</div>
					<div class="fs-14 lh-24 text-2" style="color: #686E77;">{{ v.info }}</div>
					<OImage class="news-img" :src="v.img" wh="494,269"></OImage>
					<!-- 图片宽高定死，2021.03.11上午客户开发反馈 -->
				</div>
			</div>
		</div>

		<!--  -->
		<div class="flex-cs"><read-more name="Dynamic"></read-more></div>
	</div>
</template>

<script>
export default {
	name: '',
	data() {
		return {
			list: [], //数据
			list2: [], //加工后的数据，在后面增加前三个，实现无缝轮播
			current: 0, //当前下标
			timer: null, //轮播定时器
			timerout: null, //重置位置定时器
			style: '' //样式，通过监听下标变化得到
		};
	},
	created() {
		this.$get({
			url: 'app/getNews',
			data: {
				pageSize: 10,
				pageNo: 1,
				type: 1
			},
			success: res => {
				let list = res.page.list.map((v, i) => {
					v.index = i;
					return v;
				});
				this.list = list;
				this.list2 = [...list, ...list.slice(0, 3)];
			}
		});
	},
	mounted() {
		this.pay();
	},
	watch: {
		current(n, o) {
			// 点击速度很快时，不到0.6s会导致无法复位；优化思路，先秒复位后执行动画；
			// 最后一张到第一张
			if (n == 0 && o == this.list.length - 1) {
				this.style = `transform: translateX(-${(o + 1) * 6.15}rem);`;
				// this.$debug && console.log('最后一张到第一张');
				this.timerout = setTimeout(() => {
					this.style = `transform: translateX(0);transition: all 0s;`;
					// this.$debug && console.log('动画结束复位', this.style);
				}, 600);
				return;
			}
			this.style = `transform: translateX(-${n * 6.15}rem);`;
			// 第二张到第一张，动画结束后定位到重复的位置
			if (n == 0 && o == 1) {
				// this.$debug && console.log('二张到第一张');
				this.timerout = setTimeout(() => {
					this.style = `transform: translateX(-${this.list.length * 6.15}rem);transition: all 0s;`;
					// this.$debug && console.log('动画结束复位', this.style);
				}, 600);
			}
		}
	},
	beforeDestroy() {
		this.stop();
	},
	methods: {
		// 上一张
		lastOne() {
			if (this.current <= 0) {
				this.current = this.list.length - 1;
			} else {
				this.current = this.current - 1;
			}
		},
		// 自动轮播
		pay() {
			this.timer = setInterval(() => {
				this.current = this.current < this.list.length - 1 ? this.current + 1 : 0;
			}, 3000);
		},
		// 暂停轮播
		stop() {
			clearInterval(this.timer);
			this.timer = null;
		},
		// 补零
		add0(num) {
			return num >= 10 ? num : '0' + num;
		}
	}
};
</script>

<style scoped="scoped">
.box-in {
	white-space: nowrap;
	transition: all 0.6s;
	display: flex;
}
.box-item {
	flex-shrink: 0;
	display: inline-block;
	border-left: 1px solid #e0e0e0;
	white-space: pre-wrap;
	transition: all 1s;
	width: 6.15rem;
	padding: 0.26rem 0.6rem;
}
.box-item:hover .news-img {
	border-top-right-radius: 0.6rem;
	overflow: hidden;
}
.title {
	color: #686e77;
}
.box-item:hover .title,
.active-title {
	color: #2b3542;
}
.news-img {
	width: 100%;
	height: auto;
	transition: all 0.2s;
	display: block;
}

.box-num {
	font-size: 1rem;
	font-weight: bold;
	color: rgba(243, 243, 243);
}

/* 切换 */
.posi-box {
	position: absolute;
	right: 1rem;
	top: 1rem;
}
.num-box {
	display: flex;
	align-items: center;
	font-weight: bold;
}
.num-line {
	width: 0.4rem;
	margin: 0 0.1rem;
	height: 1px;
	background-color: #ababab;
}
.control {
	background-color: rgb(234, 234, 234);
	width: 0.4rem;
	height: 0.4rem;
	border-radius: 50%;
	color: #ffffff;
	line-height: 0.4rem;
	text-align: center;
	display: inline-block;
}
.control:hover {
	background-color: #d7191c;
}

.last-one,
.next-one {
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
	cursor: pointer;
	width: 0.4rem;
	height: 0.4rem;
	display: inline-block;
}
.last-one {
	background-image: url(../../assets/img/last_one3.png);
}
.next-one {
	background-image: url(../../assets/img/next_one3.png);
}
.last-one:hover {
	background-image: url(../../assets/img/last_one2.png);
}
.next-one:hover {
	background-image: url(../../assets/img/next_one2.png);
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/news.vue